import IntervalUnit from "@app/enum/IntervalUnit";

const getRangeByDuration = (
  duration: Duration,
  reverse?: boolean
): { from: number; to: number; unit: IntervalUnit } => {
  let value = 0;
  let unit = IntervalUnit.HOUR;
  if (duration.hours) {
    value = duration.hours;
  } else {
    value = duration.days as number;
    unit = IntervalUnit.DAY;
  }
  const from = reverse ? (value > 0 ? -value : 0) : value > 0 ? 0 : value;
  const to = reverse ? (value > 0 ? 0 : -value) : value > 0 ? value : 0;
  return { from, to, unit };
};

export default getRangeByDuration;
